import { InputAdornmentButton } from '@cian/ui-kit';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectHasUnderground } from 'shared/selectors/location';
import { UndergroundMapModalContainer } from '../MapModalContainer';
import { useModalState } from 'shared/hooks';
import { trackGeoSuggestClick, trackQuickFilterClick } from 'shared/utils/analytics';

export const UndergroundPopupButtonContainer: FC = () => {
  const hasUnderground = useSelector(selectHasUnderground);

  const { opened, onClose, onOpen } = useModalState();

  const handleClick = useCallback(() => {
    trackQuickFilterClick('metro');
    trackGeoSuggestClick('metro');
    onOpen();
  }, [onOpen]);

  if (!hasUnderground) {
    return null;
  }

  return (
    <>
      <InputAdornmentButton
        data-testid="UndergroundPopupButton"
        data-name="UndergroundPopupButtonContainer"
        type="button"
        onClick={handleClick}
      >
        Метро
      </InputAdornmentButton>
      {opened && <UndergroundMapModalContainer onModalClose={onClose} />}
    </>
  );
};
